"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../../static/icons/icons");

var _palette = require("../../../../styles/palette");

var _style = require("./style");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Checkbox = function (_PureComponent) {
  (0, _inherits2["default"])(Checkbox, _PureComponent);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Checkbox);
    _this = _super.call(this, props);

    _this.handleClick = function () {
      var handleClick = _this.props.handleClick;

      _this.setState(function (prevState) {
        if (handleClick) handleClick(!prevState.checked);
        return {
          checked: !prevState.checked
        };
      });
    };

    _this.state = {
      checked: props.checked
    };
    return _this;
  }

  (0, _createClass2["default"])(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          error = _this$props.error,
          id = _this$props.id,
          children = _this$props.children,
          text = _this$props.text;
      var checked = this.state.checked;
      return _react["default"].createElement(_style.InputContainer, {
        error: error
      }, _react["default"].createElement("label", {
        "data-test-id": "checkbox",
        htmlFor: id,
        onMouseDown: this.handleClick
      }, _react["default"].createElement("input", {
        type: "checkbox",
        id: id
      }), _react["default"].createElement(_style.IconStyled, {
        error: error,
        icon: checked ? _icons.ICONS.CHECKON : _icons.ICONS.CHECKOFF,
        color: error ? _palette.palette.error : _palette.palette.bobBlack,
        size: 20
      }), _react["default"].createElement(_style.Text, null, text || children)));
    }
  }]);
  return Checkbox;
}(_react.PureComponent);

Checkbox.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  error: _propTypes["default"].bool,
  handleClick: _propTypes["default"].func,
  id: _propTypes["default"].string,
  text: _propTypes["default"].string,
  checked: _propTypes["default"].bool
};
Checkbox.defaultProps = {
  children: undefined,
  error: false,
  handleClick: function handleClick() {},
  id: 'checkbox',
  text: '',
  checked: false
};
var _default = Checkbox;
exports["default"] = _default;